module.exports = __webpack_public_path__ + "static/media/fr-share-image.6a5c9e4f.jpg";